import React from 'react';

import { HtmlContainer } from 'modules/shared-ui/components';

import { TopTitleBlockProps } from './top-title-block-type';

import styles from './top-title-block-component.module.css';

export const TopTitleBlock: React.FC<TopTitleBlockProps> = ({ title, description }: TopTitleBlockProps) => {
    return (
        <div className={styles.titleContainer}>
            <div className={styles.title}>{title}</div>
            <HtmlContainer className={styles.description} htmlContent={description} />
        </div>
    );
};
